import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

export function TextOverlay({ text = null, className = 'justify-content-center size-20 text-white' }) {
  return (
    !!text && (
      <div
        className={classnames(
          'overlay pos-a top-0 right-0 d-flex align-items-center h-100 w-100 rounded-12',
          className
        )}
        aria-hidden
      >
        {text}
      </div>
    )
  );
}

TextOverlay.propTypes = {
  text: PropTypes.string,
  className: PropTypes.string,
};
